import React from 'react'
import map from 'lodash/map'

import { withStyles, withTheme } from 'pmt-ui/styles'
import Typography from 'pmt-ui/Typography'
import { CardBasic, CardPostIt } from 'pmt-ui/Card'
import SocialPerson from 'pmt-ui/svg-icons/social/person'
import LogoGrey from 'pmt-ui/svg-icons/pmt/LogoGrey'

import calendarPart from './parts/calendar'
import listChooserPart from './parts/listChooser'
import stepperPart from './parts/stepper'

import { SectionList } from '../../components'

const styles = theme => ({
  app: {
    width: '100%',
    maxWidth: '1430px',
    margin: '0 auto',
    padding: theme.spacing(4),
  },
  logoContainer: {
    textAlign: 'center',
    marginBottom: theme.spacing(5),
  },
  logo: {
    width: '100%',
    maxWidth: 400,
    height: 125,
  },
  title: {
    textAlign: 'left',
  },
  introduction: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  color: {
    width: '100%',
    height: 80,
    textAlign: 'center',
    lineHeight: '80px',
  },
  red400Background: {
    backgroundColor: theme.pmt.colors.red400,
  },
  orange300Background: {
    backgroundColor: theme.pmt.colors.orange300,
  },
  lightGreen400Background: {
    backgroundColor: theme.pmt.colors.lightGreen400,
  },
  blue700Background: {
    backgroundColor: theme.pmt.colors.blue700,
  },
  grey500Background: {
    backgroundColor: theme.pmt.colors.grey500,
  },
  brown400Background: {
    backgroundColor: theme.pmt.colors.brown400,
  },
  pink400Background: {
    backgroundColor: theme.pmt.colors.pink400,
  },
  yellow400Background: {
    backgroundColor: theme.pmt.colors.yellow400,
  },
})

class StyleGuidePage extends React.Component {
  render() {
    const { classes, theme } = this.props

    const colorComponents = map(theme.pmt.colors, (color, index) => {
      return {
        name: index,
        definition: `theme.pmt.colors.${index}`,
        render: <div className={`${classes.color} ${classes[`${index}Background`]}`}>{index}</div>,
      }
    })

    return (
      <div className={classes.app}>
        <div className={classes.logoContainer}>
          <LogoGrey viewBox={'0 0 150 43.5'} className={classes.logo} />
        </div>
        <Typography variant="h5" className={classes.title}>
          PayMyTable's styleguide
        </Typography>
        <Typography variant="body2" className={classes.introduction}>
          Welcome to PayMyTable's styleguide. You will find here everything you need, from component
          structure to rendering properties.
          <br />
          Have some fun discovering this great toolbox.
          <br />
          <br />
          The props showed in example are not an exhaustive list. Don't hesitate to check the
          component code.
        </Typography>
        <SectionList
          list={[
            {
              title: 'Colors',
              components: colorComponents,
            },
            {
              title: 'Cards',
              components: [
                {
                  name: 'Basic card',
                  definition: '<CardBasic color={theme.pmt.colors.grey500} />',
                  render: (
                    <CardBasic
                      color={theme.pmt.colors.grey500}
                      header={{
                        avatar: <SocialPerson viewBox={'0 0 24 24'} />,
                        title: 'Title example',
                      }}
                      content={<div>Content example</div>}
                    />
                  ),
                  resizer: true,
                },
                {
                  name: 'Basic green card',
                  definition: '<CardBasic color={theme.pmt.colors.lightGreen400} />',
                  render: (
                    <CardBasic
                      color={theme.pmt.colors.lightGreen400}
                      header={{
                        avatar: <SocialPerson viewBox={'0 0 24 24'} />,
                        title: 'Title example',
                      }}
                      content={<div>Content example</div>}
                    />
                  ),
                  resizer: true,
                },
                {
                  name: 'Post it card',
                  definition: '<CardPostIt />',
                  render: (
                    <CardPostIt
                      color={{
                        background: theme.pmt.colors.primary50,
                        border: theme.palette.primary.main,
                        font: theme.palette.primary.main,
                      }}
                      header={{
                        avatar: <SocialPerson viewBox={'0 0 24 24'} />,
                        title: 'Title example',
                      }}
                      content={<div>Content example</div>}
                    />
                  ),
                  resizer: true,
                },
              ],
            },
            calendarPart,
            listChooserPart,
            stepperPart,
          ]}
        />
      </div>
    )
  }
}

export default withTheme(withStyles(styles)(StyleGuidePage))
